<template>
    <div class="banner flex">
        <div class="leftBox flexColumn">
            <box-border
                title="累计运输货量统计"
                height="30%"
                padding="0.2rem 0.2rem 0.1rem"
            >
                <echart-module
                    ref="totalStatistics"
                    :option="totalStatistics"
                ></echart-module>
            </box-border>
            <box-border
                title="运输货量统计"
                height="30%"
                padding="0.2rem 0.2rem 0.1rem"
            >
                <echart-module
                    ref="volumeStatistics"
                    :option="volumeStatistics"
                ></echart-module>
            </box-border>
            <box-border
                title="运输进度"
                height="15%"
                margin="0.1rem 0 0 0"
            >
                <echart-module
                    ref="transportProgress"
                    :option="transportProgress"
                ></echart-module>
            </box-border>
            <div class="flexColumn" style="height: 15%;width: 100%;">
                <div class="lineBorder"></div>
                <div :style="{
                    height: '95%',
                    background: '#0b1547',
                    padding: '0 0.2rem'
                }">
                    <scroll-text
                        ref="scrollText"
                        :loadData="logisticsDatas"
                        showName="v1"
                        firstChild="lastChild"
                        :style="{
                            background: '#0b1547'
                        }"
                        :liStyle="{
                            'font-size': '.14rem',
                            'font-family': 'Microsoft YaHei',
                            'font-weight': 400,
                            'color': '#FFFFFF',
                            'line-height': '.22rem',
                            'white-space': 'normal'
                        }"
                    >
                        <template #default="{ data }">
                            <span @click="goToLink" v-html="getSpan(data['v1'])"></span>
                        </template>
                    </scroll-text>
                </div>
                <div class="lineBorder"></div>
            </div>
        </div>
        <div ref="worldMap" class="world"></div>
        <div class="rightNode flexColumnAround">
            <div class="flexColumn" style="height: 100%;width: 100%;">
                <div class="lineBorder"></div>
                <div :style="{
                    height: '95%',
                    background: '#0b1547',
                    padding: '0 0.2rem'
                }">
                    <top-tab
                        class="scrollStyle"
                        :topBarDatas="topBarDatas"
                        :getStyle="(item) => {
                            return {
                                'background': item.v5,
                            }
                        }"
                        :getIconStyle="(item) => {
                            return {
                                'backgroundImage': `url(${require(`@/assets/Logistics/${item.v6}.png`)})`
                            }
                        }"
                        :nameStyle="{
                            color: '#fff'
                        }"
                        :divStyle="{
                            'height': 'auto',
                            'margin-bottom': '0',
                            'margin-right': '0',
                            'box-sizing': 'border-box'
                        }"
                        :boxStyle="{
                            'contain': 'layout',
                            'height': '100%',
                            'display': 'grid',
                            'overflow-x': 'hidden',
                            'overflow-y': 'auto',
                            'grid-template-columns': 'repeat(2, 1fr)',
                            'grid-row-gap': '0.1rem',
                            'grid-column-gap': '0.1rem'
                        }"
                    ></top-tab>
                </div>
                <div class="lineBorder"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { servedetailUsingGET } from '../api/dataapi';
    export default {
        name: 'Logistics',
        data(){
            return {
                //物流管理驾驶舱
                volumeStatistics: {
                    grid: {
                        top: '10%',
                        bottom: this.fontSizeFn(40)
                    },
                    showZoom: true
                },
                //累计运输货量统计
                totalStatistics: {
                    grid: {
                        top: '10%',
                        bottom: this.fontSizeFn(40)
                    },
                    showZoom: true
                },
                //运输进度
                transportProgress: {
                    tooltip: {
                        formatter([{data}]){
                            const span = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>`;
                            let str = data.name + '<br/>';
                            str += span + ' 已运输 ' + data.s3 + '<br/>';
                            str += span + ' 未运输 ' + data.s4 + '<br/>';
                            str += span + ' 总数量 ' + data.s2 + '<br/>';
                            str += span + ' 百分比 ' + data.value + '%';
                            return str;
                        }
                    }
                },
                //弹出层数据
                tooltipDatas: [],
                allIcons: [
                    {
                        name: '天津港',
                        value: [117.5852506, 38.8716702],
                        itemStyle: {
                            color: 'rgb(255, 204, 0)',
                            opacity: 1
                        },
                        //小船
                        symbol: 'circle',
                        // symbol: 'path://M509.824 117.333333a202.666667 202.666667 0 0 1 202.666667 202.666667c0 99.84-72.213333 182.826667-167.253334 199.594667l-0.042666 110.613333h105.792v64h-105.792v122.837333a351.701333 351.701333 0 0 0 237.866666-125.824l-58.944-35.434666 167.744-92.8-3.178666 191.68-50.197334-30.165334a415.701333 415.701333 0 0 1-293.269333 156.778667v100.394667h-64v-100.202667a415.701333 415.701333 0 0 1-297.408-159.168L129.92 754.666667l-3.157333-191.68 167.744 92.8-55.381334 33.28a351.701333 351.701333 0 0 0 242.048 128.192V694.186667h-107.456v-64h107.456v-109.546667c-96.512-13.653333-171.157333-95.274667-173.952-194.901333l-0.085333-5.76a202.666667 202.666667 0 0 1 202.666667-202.666667z m0 64a138.666667 138.666667 0 1 0 0 277.333334 138.666667 138.666667 0 0 0 0-277.333334z'
                    },
                    {
                        name: '青岛港',
                        value: [120.3298527, 36.0932162],
                        itemStyle: {
                            color: 'rgb(255, 204, 0)',
                            opacity: 1
                        },
                        //小船
                        symbol: 'circle',
                        // symbol: 'path://M509.824 117.333333a202.666667 202.666667 0 0 1 202.666667 202.666667c0 99.84-72.213333 182.826667-167.253334 199.594667l-0.042666 110.613333h105.792v64h-105.792v122.837333a351.701333 351.701333 0 0 0 237.866666-125.824l-58.944-35.434666 167.744-92.8-3.178666 191.68-50.197334-30.165334a415.701333 415.701333 0 0 1-293.269333 156.778667v100.394667h-64v-100.202667a415.701333 415.701333 0 0 1-297.408-159.168L129.92 754.666667l-3.157333-191.68 167.744 92.8-55.381334 33.28a351.701333 351.701333 0 0 0 242.048 128.192V694.186667h-107.456v-64h107.456v-109.546667c-96.512-13.653333-171.157333-95.274667-173.952-194.901333l-0.085333-5.76a202.666667 202.666667 0 0 1 202.666667-202.666667z m0 64a138.666667 138.666667 0 1 0 0 277.333334 138.666667 138.666667 0 0 0 0-277.333334z'
                    },
                    {
                        name: '上海港',
                        value: [121.4956022, 31.3701898],
                        itemStyle: {
                            color: 'rgb(255, 204, 0)',
                            opacity: 1
                        },
                        //小船
                        symbol: 'circle',
                        // symbol: 'path://M509.824 117.333333a202.666667 202.666667 0 0 1 202.666667 202.666667c0 99.84-72.213333 182.826667-167.253334 199.594667l-0.042666 110.613333h105.792v64h-105.792v122.837333a351.701333 351.701333 0 0 0 237.866666-125.824l-58.944-35.434666 167.744-92.8-3.178666 191.68-50.197334-30.165334a415.701333 415.701333 0 0 1-293.269333 156.778667v100.394667h-64v-100.202667a415.701333 415.701333 0 0 1-297.408-159.168L129.92 754.666667l-3.157333-191.68 167.744 92.8-55.381334 33.28a351.701333 351.701333 0 0 0 242.048 128.192V694.186667h-107.456v-64h107.456v-109.546667c-96.512-13.653333-171.157333-95.274667-173.952-194.901333l-0.085333-5.76a202.666667 202.666667 0 0 1 202.666667-202.666667z m0 64a138.666667 138.666667 0 1 0 0 277.333334 138.666667 138.666667 0 0 0 0-277.333334z'
                    },
                    {
                        name: 'Mombasa',
                        value: [39.672634115, -4.058034],
                        itemStyle: {
                            color: 'rgb(255, 204, 0)',
                            opacity: 1
                        },
                        //小车
                        symbol: 'circle',
                        // symbol: 'path://M509.824 117.333333a202.666667 202.666667 0 0 1 202.666667 202.666667c0 99.84-72.213333 182.826667-167.253334 199.594667l-0.042666 110.613333h105.792v64h-105.792v122.837333a351.701333 351.701333 0 0 0 237.866666-125.824l-58.944-35.434666 167.744-92.8-3.178666 191.68-50.197334-30.165334a415.701333 415.701333 0 0 1-293.269333 156.778667v100.394667h-64v-100.202667a415.701333 415.701333 0 0 1-297.408-159.168L129.92 754.666667l-3.157333-191.68 167.744 92.8-55.381334 33.28a351.701333 351.701333 0 0 0 242.048 128.192V694.186667h-107.456v-64h107.456v-109.546667c-96.512-13.653333-171.157333-95.274667-173.952-194.901333l-0.085333-5.76a202.666667 202.666667 0 0 1 202.666667-202.666667z m0 64a138.666667 138.666667 0 1 0 0 277.333334 138.666667 138.666667 0 0 0 0-277.333334z'
                    },
                    {
                        name: 'Lake albert',
                        value: [30.9951576, 1.4331481],
                        itemStyle: {
                            color: 'rgb(255, 204, 0)',
                            opacity: 1
                        },
                        //帐篷
                        symbol: 'circle',
                        // symbol: 'path://M812.8 521.6c-64-64-163.2-108.8-252.8-128 76.8 76.8 160 243.2 179.2 601.6 0-3.2 3.2-3.2 3.2-6.4 16-16 41.6-41.6 70.4-60.8 19.2-12.8 64-22.4 96-16 32 6.4 44.8 9.6 44.8-19.2C960 758.4 918.4 620.8 812.8 521.6z,path://M409.6 736c-54.4 3.2-112 83.2-115.2 208 22.4 0 44.8 0 70.4 0 54.4 0 102.4 6.4 147.2 12.8 0-3.2 0-9.6 0-12.8C512 835.2 464 732.8 409.6 736z,path://M611.2 99.2c-6.4-3.2-35.2-9.6-48-6.4-19.2 6.4-60.8 60.8-73.6 115.2-12.8 51.2-12.8 172.8-12.8 172.8-124.8 0-233.6 64-310.4 172.8-73.6 108.8-96 259.2-102.4 380.8 0 28.8 54.4 12.8 83.2 12.8 35.2-3.2 70.4-3.2 108.8-3.2 0-144 70.4-246.4 150.4-243.2 86.4 3.2 140.8 105.6 140.8 246.4 0 3.2 0 12.8 0 19.2 38.4 9.6 76.8 19.2 115.2 28.8 19.2 6.4 35.2 12.8 44.8 16C697.6 758.4 640 486.4 515.2 393.6 505.6 352 508.8 313.6 512 278.4c105.6 38.4 220.8 28.8 240-22.4C780.8 182.4 643.2 118.4 611.2 99.2zM713.6 243.2c-6.4 19.2-41.6 28.8-83.2 25.6-48-3.2-105.6-22.4-108.8-25.6-3.2-9.6 6.4-35.2 16-60.8 9.6-22.4 25.6-44.8 38.4-44.8C592 134.4 726.4 198.4 713.6 243.2z'
                    },
                    {
                        name: 'Malaba',
                        value: [34.264053317, 0.6387253],
                        itemStyle: {
                            color: 'rgb(255, 204, 0)',
                            opacity: 1
                        },
                        //小车
                        symbol: 'circle',
                        // symbol: 'path://M1022.256427 704L930.30976 285.866667a16.213333 16.213333 0 0 0-1.28-4.266667 97.493333 97.493333 0 0 0-83.413333-62.08l21.333333-19.84a95.786667 95.786667 0 0 0 101.12-20.266667 90.026667 90.026667 0 0 0 0-129.493333 96 96 0 0 0-132.906667 0 89.6 89.6 0 0 0-17.066666 106.666667l-18.56 17.92a95.36 95.36 0 0 0-64-80.853334l-4.48-1.28L302.043093 1.706667a32.64 32.64 0 0 0-32.426666 52.693333l52.693333 61.226667a33.706667 33.706667 0 0 0 19.413333 11.093333l56.106667 10.24a33.28 33.28 0 0 0 39.04-25.813333 35.413333 35.413333 0 0 0 0-14.933334l277.333333 58.026667A30.08 30.08 0 0 1 730.843093 192L704.176427 263.68a37.973333 37.973333 0 0 0-4.906667 6.613333l-55.893333 54.4a199.253333 199.253333 0 0 1-36.693334-97.92c-2.773333-23.04-2.56-23.04 14.293334-22.826666a32.426667 32.426667 0 1 0 1.28-64C563.803093 137.813333 533.50976 173.44 540.54976 234.666667a257.706667 257.706667 0 0 0 25.813333 91.093333A141.013333 141.013333 0 0 0 448.176427 362.666667a136.533333 136.533333 0 0 0-36.906667 64L67.58976 91.733333A34.133333 34.133333 0 0 0 21.50976 91.733333a31.786667 31.786667 0 0 0 0 45.866667l39.68 39.893333-51.413333 50.133334a31.786667 31.786667 0 0 0 0 45.866666 33.706667 33.706667 0 0 0 47.146666 0l51.413334-50.133333 27.946666 27.093333L85.50976 300.586667a32 32 0 0 0 0 46.08 34.133333 34.133333 0 0 0 47.146667 0l51.626666-50.346667 27.733334 27.093333-52.266667 50.346667a31.786667 31.786667 0 0 0 0 45.866667 34.133333 34.133333 0 0 0 47.146667 0l51.413333-50.133334 108.373333 105.386667a118.826667 118.826667 0 0 0-69.76 131.84A118.186667 118.186667 0 0 0 207.74976 640a111.146667 111.146667 0 0 0-21.333333 130.56l-163.413334 158.506667a31.786667 31.786667 0 0 0 0 45.866666 34.133333 34.133333 0 0 0 47.146667 0l161.493333-157.44a118.826667 118.826667 0 0 0 141.226667-17.28A111.36 111.36 0 0 0 405.50976 704a125.013333 125.013333 0 0 0 101.333333-34.346667 118.4 118.4 0 0 0 24.32-34.56l174.72 170.666667c-41.6 57.173333-41.386667 126.72 10.88 177.706667 60.16 58.453333 145.493333 50.133333 207.786667-10.453334s70.826667-144 10.666667-202.453333a138.24 138.24 0 0 0-182.186667-10.666667l-173.226667-168.96a139.733333 139.733333 0 0 0 66.133334-36.266666 133.333333 133.333333 0 0 0 40.106666-109.226667 277.333333 277.333333 0 0 0 94.933334 29.226667 128 128 0 0 0 13.013333 1.28c44.373333 3.413333 75.52-13.866667 85.333333-46.08a67.2 67.2 0 0 0-10.24-62.72 34.133333 34.133333 0 0 0-47.146666 0 32.426667 32.426667 0 0 0-5.333334 38.186666 15.573333 15.573333 0 0 1 0 4.48 40.106667 40.106667 0 0 1-17.706666 1.493334l-9.386667-0.853334a208.64 208.64 0 0 1-99.413333-39.04l55.466666-54.186666a36.266667 36.266667 0 0 0 8.106667-5.546667l72.96-26.026667a31.573333 31.573333 0 0 1 39.253333 16.426667l59.733334 270.72a31.36 31.36 0 0 0-15.36 0 32.64 32.64 0 0 0-26.88 37.333333l10.88 54.613334a31.573333 31.573333 0 0 0 11.306666 18.986666l62.72 51.2A33.066667 33.066667 0 0 0 1022.256427 704zM495.963093 408.96a74.026667 74.026667 0 0 1 77.44-16l-90.453333 88.106667-5.12-2.773334a68.693333 68.693333 0 0 1 18.133333-69.333333z m-117.76 135.68a56.96 56.96 0 0 1 42.666667-16.213333l6.4 6.186666-64 64a54.4 54.4 0 0 1 14.933333-53.973333z m-123.306666 140.8a49.92 49.92 0 0 1 32.64-14.08l-46.933334 45.866667a47.573333 47.573333 0 0 1 14.293334-31.786667z m70.826666 68.906667a50.56 50.56 0 0 1-42.666666 13.44l56.746666-55.253334a48.213333 48.213333 0 0 1-14.08 41.813334z m133.76-130.56a57.6 57.6 0 0 1-45.226666 16l60.8-59.306667v1.066667a55.04 55.04 0 0 1-15.573334 42.24z m428.373334 192c31.786667 30.933333 27.52 73.386667-10.666667 110.506666-38.186667 37.12-81.706667 41.173333-113.493333 10.24a64 64 0 0 1-8.96-85.333333 33.706667 33.706667 0 0 0 41.173333-3.84 32.213333 32.213333 0 0 0 4.48-40.32 68.906667 68.906667 0 0 1 87.466667 8.746667zM598.78976 509.013333a73.386667 73.386667 0 0 1-69.12 18.346667l87.893333-85.333333a69.333333 69.333333 0 0 1-18.773333 66.986666z'
                    },
                    {
                        name: 'Dar es Salaam',
                        value: [39.220301313, -6.8304482],
                        itemStyle: {
                            color: 'rgb(255, 204, 0)',
                            opacity: 1
                        },
                        //小车
                        symbol: 'circle',
                        // symbol: 'path://M509.824 117.333333a202.666667 202.666667 0 0 1 202.666667 202.666667c0 99.84-72.213333 182.826667-167.253334 199.594667l-0.042666 110.613333h105.792v64h-105.792v122.837333a351.701333 351.701333 0 0 0 237.866666-125.824l-58.944-35.434666 167.744-92.8-3.178666 191.68-50.197334-30.165334a415.701333 415.701333 0 0 1-293.269333 156.778667v100.394667h-64v-100.202667a415.701333 415.701333 0 0 1-297.408-159.168L129.92 754.666667l-3.157333-191.68 167.744 92.8-55.381334 33.28a351.701333 351.701333 0 0 0 242.048 128.192V694.186667h-107.456v-64h107.456v-109.546667c-96.512-13.653333-171.157333-95.274667-173.952-194.901333l-0.085333-5.76a202.666667 202.666667 0 0 1 202.666667-202.666667z m0 64a138.666667 138.666667 0 1 0 0 277.333334 138.666667 138.666667 0 0 0 0-277.333334z'
                    },
                    {
                        name: 'Mutukula',
                        value: [31.41126416, -1.0010621],
                        itemStyle: {
                            color: 'rgb(255, 204, 0)',
                            opacity: 1
                        },
                        //小车
                        symbol: 'circle',
                        // symbol: 'path://M1022.256427 704L930.30976 285.866667a16.213333 16.213333 0 0 0-1.28-4.266667 97.493333 97.493333 0 0 0-83.413333-62.08l21.333333-19.84a95.786667 95.786667 0 0 0 101.12-20.266667 90.026667 90.026667 0 0 0 0-129.493333 96 96 0 0 0-132.906667 0 89.6 89.6 0 0 0-17.066666 106.666667l-18.56 17.92a95.36 95.36 0 0 0-64-80.853334l-4.48-1.28L302.043093 1.706667a32.64 32.64 0 0 0-32.426666 52.693333l52.693333 61.226667a33.706667 33.706667 0 0 0 19.413333 11.093333l56.106667 10.24a33.28 33.28 0 0 0 39.04-25.813333 35.413333 35.413333 0 0 0 0-14.933334l277.333333 58.026667A30.08 30.08 0 0 1 730.843093 192L704.176427 263.68a37.973333 37.973333 0 0 0-4.906667 6.613333l-55.893333 54.4a199.253333 199.253333 0 0 1-36.693334-97.92c-2.773333-23.04-2.56-23.04 14.293334-22.826666a32.426667 32.426667 0 1 0 1.28-64C563.803093 137.813333 533.50976 173.44 540.54976 234.666667a257.706667 257.706667 0 0 0 25.813333 91.093333A141.013333 141.013333 0 0 0 448.176427 362.666667a136.533333 136.533333 0 0 0-36.906667 64L67.58976 91.733333A34.133333 34.133333 0 0 0 21.50976 91.733333a31.786667 31.786667 0 0 0 0 45.866667l39.68 39.893333-51.413333 50.133334a31.786667 31.786667 0 0 0 0 45.866666 33.706667 33.706667 0 0 0 47.146666 0l51.413334-50.133333 27.946666 27.093333L85.50976 300.586667a32 32 0 0 0 0 46.08 34.133333 34.133333 0 0 0 47.146667 0l51.626666-50.346667 27.733334 27.093333-52.266667 50.346667a31.786667 31.786667 0 0 0 0 45.866667 34.133333 34.133333 0 0 0 47.146667 0l51.413333-50.133334 108.373333 105.386667a118.826667 118.826667 0 0 0-69.76 131.84A118.186667 118.186667 0 0 0 207.74976 640a111.146667 111.146667 0 0 0-21.333333 130.56l-163.413334 158.506667a31.786667 31.786667 0 0 0 0 45.866666 34.133333 34.133333 0 0 0 47.146667 0l161.493333-157.44a118.826667 118.826667 0 0 0 141.226667-17.28A111.36 111.36 0 0 0 405.50976 704a125.013333 125.013333 0 0 0 101.333333-34.346667 118.4 118.4 0 0 0 24.32-34.56l174.72 170.666667c-41.6 57.173333-41.386667 126.72 10.88 177.706667 60.16 58.453333 145.493333 50.133333 207.786667-10.453334s70.826667-144 10.666667-202.453333a138.24 138.24 0 0 0-182.186667-10.666667l-173.226667-168.96a139.733333 139.733333 0 0 0 66.133334-36.266666 133.333333 133.333333 0 0 0 40.106666-109.226667 277.333333 277.333333 0 0 0 94.933334 29.226667 128 128 0 0 0 13.013333 1.28c44.373333 3.413333 75.52-13.866667 85.333333-46.08a67.2 67.2 0 0 0-10.24-62.72 34.133333 34.133333 0 0 0-47.146666 0 32.426667 32.426667 0 0 0-5.333334 38.186666 15.573333 15.573333 0 0 1 0 4.48 40.106667 40.106667 0 0 1-17.706666 1.493334l-9.386667-0.853334a208.64 208.64 0 0 1-99.413333-39.04l55.466666-54.186666a36.266667 36.266667 0 0 0 8.106667-5.546667l72.96-26.026667a31.573333 31.573333 0 0 1 39.253333 16.426667l59.733334 270.72a31.36 31.36 0 0 0-15.36 0 32.64 32.64 0 0 0-26.88 37.333333l10.88 54.613334a31.573333 31.573333 0 0 0 11.306666 18.986666l62.72 51.2A33.066667 33.066667 0 0 0 1022.256427 704zM495.963093 408.96a74.026667 74.026667 0 0 1 77.44-16l-90.453333 88.106667-5.12-2.773334a68.693333 68.693333 0 0 1 18.133333-69.333333z m-117.76 135.68a56.96 56.96 0 0 1 42.666667-16.213333l6.4 6.186666-64 64a54.4 54.4 0 0 1 14.933333-53.973333z m-123.306666 140.8a49.92 49.92 0 0 1 32.64-14.08l-46.933334 45.866667a47.573333 47.573333 0 0 1 14.293334-31.786667z m70.826666 68.906667a50.56 50.56 0 0 1-42.666666 13.44l56.746666-55.253334a48.213333 48.213333 0 0 1-14.08 41.813334z m133.76-130.56a57.6 57.6 0 0 1-45.226666 16l60.8-59.306667v1.066667a55.04 55.04 0 0 1-15.573334 42.24z m428.373334 192c31.786667 30.933333 27.52 73.386667-10.666667 110.506666-38.186667 37.12-81.706667 41.173333-113.493333 10.24a64 64 0 0 1-8.96-85.333333 33.706667 33.706667 0 0 0 41.173333-3.84 32.213333 32.213333 0 0 0 4.48-40.32 68.906667 68.906667 0 0 1 87.466667 8.746667zM598.78976 509.013333a73.386667 73.386667 0 0 1-69.12 18.346667l87.893333-85.333333a69.333333 69.333333 0 0 1-18.773333 66.986666z'
                    },
                ],
                seriesDatas: [],
                allBarDatas: [],
                topBarDatas: [],
                logisticsDatas: Promise.resolve([]),
                worldOptions: {
                    tooltip: {
                        trigger: 'item',
                        confine: true,
                        axisPointer: {
                            type: 'shadow',
                            crossStyle: {
                                color: '#999',
                            },
                        },
                        textStyle: {
                            color: '#ffffff',
                            fontSize: this.fontSizeFn(14),
                        },
                        extraCssText: 'border-color: rgba(0, 0, 0, 0.5);background-color: rgba(0, 0, 0, 0.5);',
                    },
                    geo: {
                        map: 'world',
                        itemStyle: {
                            areaColor: '#014b84',
                            borderColor: '#ffffff',
                        },
                        emphasis: {
                            itemStyle: {
                                areaColor: '#fff'
                            }
                        },
                        roam: true,
                        selectedMode: 'single',
                        zoom: 3,
                        center: [65, 19],
                        regions: [],
                        silent: false,
                        tooltip: {
                            show: true
                        }
                    },
                    series: [
                        {
                            name: '值',
                            type: 'effectScatter' || 'scatter',
                            coordinateSystem: 'geo',
                            // symbolSize: 16,
                            data: [],
                            label: {
                                show: false,
                            },
                            tooltip: {
                                formatter: (params) => {
                                    let html = `<span style="font-size: 0.18rem;font-weight: 700;">${params.name}</span><br/>`;
                                    const value = this.tooltipDatas.find(item => item.name === params.name).value;
                                    value && (html += value);
                                    return html;
                                }
                            }
                        },
                        {
                            coordinateSystem: 'geo',
                            geoIndex: 0,
                            name: '',
                            z: 3,
                            type: 'lines',
                            symbolSize: 12,
                            tooltip: {
                                show: false
                            },
                            data: []
                        }
                    ]
                },
                //世界地图数据
                worldDatas: null,
                zhWorld: null,
                chart: null,
                //轨迹点位集合
                locusMap: null
            }
        },
        async mounted() {
            const url = window.location.origin + (process.env.NODE_ENV === 'production' ? '/uganda/general' : '');
            this.chart = this.$echarts.init(this.$refs.worldMap);
            this.worldDatas = await ((await fetch(url + '/json/world.json')).json());
            this.zhWorld = await ((await fetch(url + '/json/country-name-zh.json')).json());
            //获取topBarDatas
            Promise.all([
                //获取icon集合
                servedetailUsingGET({ chartid: '2c92808382ee082a0182ee0e786c0000', dataindex: 0, stype: 0 }),
                //获取轨迹点位集合
                servedetailUsingGET({ chartid: '2c92808783c55c810183ea0c1d1e0173', dataindex: 0, stype: 0 })
            ]).then(([res, result]) => {
                this.allBarDatas = res;
                this.locusMap = result;
                res.forEach(item => {
                    if(!this.topBarDatas.find(val => val.name === item.v1)){
                        this.topBarDatas.push({
                            name: item.v1,
                            v5: item.v5,
                            v6: item.v6,
                            fn: () => {
                                this.changeIconDatas(item.v1)
                            }
                        })
                    }
                })
                this.topBarDatas[0].fn();
            })
            //运输货量统计
            this.getNewVTos(
                {
                    id: '8acba68d82d9ba070182f1811dc2004a',
                    stype: 0
                },
                [
                    ['件杂货（吨）', '集装箱（个）'],
                    ['line', 'line'],
                    [1, 0]
                ],
                this.$refs.volumeStatistics.myChart,
                {
                    name: 'volumeStatistics',
                }
            );
            //累计运输货量统计
            this.getNewVTos(
                {
                    id: '8acba68d87798b1801877b6702ef000a',
                    stype: 0
                },
                [
                    ['件杂货（吨）', '集装箱（个）'],
                    ['line', 'line'],
                    [1, 0]
                ],
                this.$refs.totalStatistics.myChart,
                {
                    name: 'totalStatistics',
                }
            );
            //运输进度
            this.TransverseColumns(
                {
                    id: '8acba68d82d9ba070182f181b192004b',
                    stype: 0
                },
                {
                    name: 'transportProgress',
                    chart: this.$refs.transportProgress.myChart,
                    nameArr: [
                        ['值'],
                        ['bar']
                    ],
                    notShowLegend: true,
                    hasMoreData: ['s2', 's3', 's4'],
                    dataSettings: {
                        label: {
                            show: true,
                            formatter: '{c}%',
                            fontSize: this.fontSizeFn(14),
                            fontWeight: 'bolder',
                            color: '#fff'
                        }
                    }
                }
            )
        },
        methods: {
            goToLink(){
                window.open(`${location.origin}/uganda/logistics/WuProcBatchFp`)
            },
            getSpan(val){
                const str = val.replaceAll('\n', '<br/>');
                return `${str}`
            },
            changeIconDatas(v1){
                //获取颜色
                const filterArr = this.allBarDatas.filter(item => item.v1 === v1);
                //拿到去重后的name
                this.tooltipDatas = [];
                filterArr.forEach(obj => {
                    const nowObj = this.tooltipDatas.find(tool => tool.name === obj.v2);
                    if(nowObj){
                        nowObj.value += `<br/>${obj.v4}`;
                    }else{
                        this.tooltipDatas.push({
                            name: obj.v2,
                            value: obj.v4,
                            otherKey: obj.v5
                        })
                    }
                })
                this.seriesDatas = [];
                this.tooltipDatas.forEach(item => {
                    const obj = this.allIcons.find(val => val.name === item.name);
                    obj.itemStyle.color = '#' + filterArr.find(arrObj => arrObj.v2 === item.name).v3;
                    this.seriesDatas.push(obj);
                })
                this.worldOptions.series[0].data = this.seriesDatas;
                //去匹配路径
                const locusDatas = [];
                this.locusMap.forEach(item => {
                    if(item.v6 == v1){
                        locusDatas.push({
                            coords: [
                                item.v1.replaceAll(/\s/g, '').split(','),
                                item.v2.replaceAll(/\s/g, '').split(',')
                            ],
                            symbol: item.v5.replaceAll(/\s/g, '').split(','),
                            lineStyle: {
                                color: item.v4,
                                width: 2,
                                opacity: 1,
                                type: item.v8 || 'dashed',
                                curveness: item.v3
                            }
                        })
                    }
                })
                this.worldOptions.series[1].data = locusDatas;
                this.getMap('world');
                this.logisticsDatas = servedetailUsingGET({ chartid: '2c92808382ee082a0182ef0ba1b20008', dataindex: 0, stype: v1 })
            },
            getMap(type){
                this.chart.showLoading('default', {
                    text: 'loading',
                    color: '#fff',
                    textColor: '#fff',
                    maskColor: 'rgba(0, 0, 0, 0)',
                    zlevel: 0,
                    fontSize: 12,
                    showSpinner: true,
                    spinnerRadius: 10,
                    lineWidth: 5,
                    fontWeight: 'normal',
                    fontStyle: 'normal',
                    fontFamily: 'sans-serif'
                });
                this.chart.clear();
                if(type === 'world'){
                    this.$echarts.registerMap('world', { geoJSON: this.worldDatas });
                    this.worldOptions.geo.nameMap = this.zhWorld;
                    this.chart.setOption(this.worldOptions);
                    this.chart.dispatchAction({
                        type: 'showTip',
                        seriesIndex: 0,
                        name: this.tooltipDatas.find(item => item.otherKey == 1)?.name
                    });
                }
                this.chart.hideLoading();
            }
        },
    }
</script>
<style lang="less" scoped>
    .leftBox{
        width: 25%;
        height: 100%;
    }
    .banner{
        padding-top: 0.12rem;
        .rightNode{
            width: 25%;
            height: 100%;
        }
    }
    .world{
        width: 45%;
        height: 100%;
    }
    .newBgc{
        width: .3rem;
        height: .15rem;
        display: inline-block;
        background-image: url('../assets/homeImage/icon-new.png');
        background-size: 100% 100%;
        margin-right: .15rem;
        vertical-align: middle;
        z-index: 999;
    }
</style>